import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import LogsCls from './LogsCls';
import { OrbUserContext } from '../OrbUserContext';


export interface ILogsProps extends IUseApiProps, IWithErrorHandlingProps {
}

const Logs = (props: ILogsProps) => {
    const { userPermissions, userContext } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <LogsCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );

};

export default withErrorHandling(Logs);
